var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"900px","height":"265px"},attrs:{"id":"multiBarChart"}})}
var staticRenderFns = []

export { render, staticRenderFns }